import * as ambassadorWixRestaurantsOrdersettingsV3OrderSettings from './restaurants-ordersettings-v3-order-settings-order-settings.http.js';
import * as ambassadorWixRestaurantsOrdersettingsV3OrderSettingsTypes from './restaurants-ordersettings-v3-order-settings-order-settings.types.js';
import * as ambassadorWixRestaurantsOrdersettingsV3OrderSettingsUniversalTypes from './restaurants-ordersettings-v3-order-settings-order-settings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getOrderSettings(): __PublicMethodMetaInfo<
  'GET',
  { orderSettingsId: string },
  ambassadorWixRestaurantsOrdersettingsV3OrderSettingsUniversalTypes.GetOrderSettingsRequest,
  ambassadorWixRestaurantsOrdersettingsV3OrderSettingsTypes.GetOrderSettingsRequest,
  ambassadorWixRestaurantsOrdersettingsV3OrderSettingsUniversalTypes.GetOrderSettingsResponse,
  ambassadorWixRestaurantsOrdersettingsV3OrderSettingsTypes.GetOrderSettingsResponse
> {
  const payload = { orderSettingsId: ':orderSettingsId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOrdersettingsV3OrderSettings.getOrderSettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/order-settings/{orderSettingsId}',
    pathParams: { orderSettingsId: 'orderSettingsId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateOrderSettings(): __PublicMethodMetaInfo<
  'PATCH',
  { orderSettingsId: string },
  ambassadorWixRestaurantsOrdersettingsV3OrderSettingsUniversalTypes.UpdateOrderSettingsRequest,
  ambassadorWixRestaurantsOrdersettingsV3OrderSettingsTypes.UpdateOrderSettingsRequest,
  ambassadorWixRestaurantsOrdersettingsV3OrderSettingsUniversalTypes.UpdateOrderSettingsResponse,
  ambassadorWixRestaurantsOrdersettingsV3OrderSettingsTypes.UpdateOrderSettingsResponse
> {
  const payload = { orderSettings: { id: ':orderSettingsId' } } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOrdersettingsV3OrderSettings.updateOrderSettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v3/order-settings/{orderSettings.id}',
    pathParams: { orderSettingsId: 'orderSettingsId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listOrderSettings(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixRestaurantsOrdersettingsV3OrderSettingsUniversalTypes.ListOrderSettingsRequest,
  ambassadorWixRestaurantsOrdersettingsV3OrderSettingsTypes.ListOrderSettingsRequest,
  ambassadorWixRestaurantsOrdersettingsV3OrderSettingsUniversalTypes.ListOrderSettingsResponse,
  ambassadorWixRestaurantsOrdersettingsV3OrderSettingsTypes.ListOrderSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsOrdersettingsV3OrderSettings.listOrderSettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/order-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  OrderSettings as OrderSettingsOriginal,
  ApproximateAddresses as ApproximateAddressesOriginal,
  ApproximateAddressesWithLiterals as ApproximateAddressesWithLiteralsOriginal,
  Policies as PoliciesOriginal,
  Policy as PolicyOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  Tips as TipsOriginal,
  TipsType as TipsTypeOriginal,
  TipsTypeWithLiterals as TipsTypeWithLiteralsOriginal,
  TippingRate as TippingRateOriginal,
  FutureOrdersSettings as FutureOrdersSettingsOriginal,
  Availability as AvailabilityOriginal,
  TimePeriod as TimePeriodOriginal,
  DayOfWeek as DayOfWeekOriginal,
  DayOfWeekWithLiterals as DayOfWeekWithLiteralsOriginal,
  SpecialHourPeriod as SpecialHourPeriodOriginal,
  ChargeRoundingStrategy as ChargeRoundingStrategyOriginal,
  ChargeRoundingStrategyWithLiterals as ChargeRoundingStrategyWithLiteralsOriginal,
  GetOrderSettingsRequest as GetOrderSettingsRequestOriginal,
  GetOrderSettingsResponse as GetOrderSettingsResponseOriginal,
  UpdateOrderSettingsRequest as UpdateOrderSettingsRequestOriginal,
  UpdateOrderSettingsResponse as UpdateOrderSettingsResponseOriginal,
  ListOrderSettingsRequest as ListOrderSettingsRequestOriginal,
  ListOrderSettingsResponse as ListOrderSettingsResponseOriginal,
} from './restaurants-ordersettings-v3-order-settings-order-settings.types.js';
